export default __webpack_public_path__ + "static/media/dexatel-logo-small.3cca9dc2.svg";